export let Font = {
  MainHeading: 16,
  Heading: 14,
  Description: 12,
  SmallDescription: 13,
  Amount: 12,
  ProductSection: 14,
  TopNavigationIcon: 26,
  MiniDiscription: 12,
};

export let F_Fammily = {
  Regular: "Regular",
  Medium: "Medium",
};